export interface IntegrationAuthenticationStatusConnectionError {
    type: 'CONNECTION_ERROR';

    message?: string;
}

export function createIntegrationAuthenticationStatusError(
    message?: string,
): IntegrationAuthenticationStatusConnectionError {
    return {
        message,
        type: 'CONNECTION_ERROR',
    };
}
